<template lang="pug">
GenericCard.customer-chooser(:ignoreMaxWidth='true' :h100='true')
  //- .sticky-top.bg-white
  .d-flex.justify-content-center.align-items-center.py-2(
    style='min-height: 72px;'
  )
    .action-icon.rounded-circle
      img(src='@/assets/menu-item-icon.svg')
    .mb-0.ml-3(style='font-size: 18px')
      | เลือกลูกค้า
  hr.m-0

  .py-3.px-4.text-center.border-bottom
    CustomInputSelect.mb-0(v-model="filterProvince")
      option(value="") เลือกจังหวัด
      option(v-for='p in provinceList', :value='p.value') {{ p.text }}
      //- option(value="bkk") กรุงเทพ
      //- option(value="cnx") เชียงใหม่

  .d-flex(style='padding: 12px 20px;')
    CustomSearchBox.w-100(
      v-model='filterSearch' placeholder='ค้นหาด้วยชื่อ' width='100%'
      :isLoading='isLoading'
    )
      //- i.fa.fa-search
  hr.m-0

  LoadedContentWrapper.flex-fill.scrollable(
    :isLoading='isLoading'
    :data='customerList'
    @reload='loadCustomers'
  )
    .customer-list
      .customer(
        :class="{'upa-is-active': value && cust.id === value.id}"
        v-for="cust in filteredCustomerList"
      )
        CustomerShortDetailButton(:data='cust' @click='customerSelected(cust)')

    .sticky-bottom.bg-white
      hr.m-0
      .px-4.py-3
        CustomPaginationSuperCompact(
          v-model='currentPage'
          :total='totalPage'
          :compact='true'
        )
</template>


<script>
/* eslint-disable arrow-body-style, no-trailing-spaces */
import CustomerShortDetailButton from './CustomerShortDetailButton.vue';

export default {
  props: [
    'value',
  ],
  watch: {
    // reload data
    filterProvince() { this.currentPage = 1; this.loadCustomers(); },
    filterSearch() { this.currentPage = 1; this.loadCustomers(); },
    currentPage() { this.loadCustomers(); },
  },
  data: () => ({
    isLoading: false,

    // FILTERS
    filterProvince: '',
    filterSearch: '',
    // LISTS
    provinceList: [],
    customerList: [],

    currentPage: 1,
    totalPage: 0,
    totalRows: 0,
    pageFirstRowIndex: 1,
  }),
  computed: {
    filteredCustomerList() {
      // const KEYWORD = this.filterSearch.toUpperCase();
      // return this.customerList.filter((item) => {
      //   return (this.filterProvince === '' || item.province === this.filterProvince)
      //       && item.name.toUpperCase().includes(KEYWORD);
      // });
      return this.customerList;
    },
  },
  async created() {
    this.loadProvinces();
    this.loadCustomers();
  },
  methods: {
    async loadCustomers() {
      this.isLoading = true;
      
      // reset data
      this.customerList = null;

      try {
        const res = await this.$api.customer.list(
          this.currentPage,
          this.filterSearch,
          this.filterProvince,
        );
        if (res.status === 200) {
          this.customerList = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
        }
      } catch (e) {
        this.customerList = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
    async loadProvinces() {
      // this.isLoading = true;
      
      const res = await this.$api.customer.provincesList();
      if (res.status === 200) {
        this.provinceList = res.data;
      }
      
      // this.isLoading = false;
    },
    customerSelected(customerData) {
      this.$emit('input', customerData);
    },
  },
  components: {
    CustomerShortDetailButton,
  },
};
</script>

<style lang="scss">
.customer-chooser {
  position: relative;

  max-width: 320px;
}
</style>
